import React from "react";
import clsx from "clsx";

import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import BaseDialog from "../../../../components/BaseDialog/BaseDialog";

import styles from "./styles";


const ConfirmationDialog = (props) => {
  const {
    classes,
    variant='normal',
    customClasses={},
    rejectButtonText,
    confirmButtonText,
    reverseDangerButtonsStyles=false,
  } = props;

  const dialogTitleClass = classes[variant];

  const mergedCustomClasses = {
    ...customClasses,
    dialogTitle: clsx(dialogTitleClass, customClasses.dialogTitle),
  };

  const isDanger = variant === 'danger';

  let confirmBtnProps = {}, rejectBtnProps = {};
  if(isDanger){
    const dangerBtnProps = {
      customClasses: {root: classes.dangerButton},
      variant: 'outlined'
    };
    if(reverseDangerButtonsStyles){
      rejectBtnProps = dangerBtnProps
    } else {
      confirmBtnProps = dangerBtnProps
    }
  }

  return (
    <BaseDialog
      title={isDanger ? <><i className={"far fa-exclamation-triangle"}/>{props.title}</> : props.title}
      maxWidth='sm'
      disableBackdropClick
      open={props.open}
      handleClose={props.onCancel}
      modalLoading={props.loading}
      customClasses={mergedCustomClasses}
      actions={
        <Grid container spacing={2} justify={"flex-end"}>
          <Grid item>
            <PrimaryButton
              {...rejectBtnProps}
              text={rejectButtonText || 'Abbrechen'}
              variant={'outlined'}
              onButtonClick={props.onClose}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              {...confirmBtnProps}
              text={confirmButtonText || 'Ja'}
              onButtonClick={props.confirm}
            />
          </Grid>
        </Grid>
      }
    >
      <div className={clsx(classes.messageContent, customClasses.messageContent)}>
        {props.message}
      </div>
    </BaseDialog>
  )
}

export default withStyles(styles)(ConfirmationDialog);
